import { useState, useEffect, useCallback } from 'react';
import { find, keys } from 'lodash';
import { breakpoints } from 'config/breakpoints';
import { getWindowWidth, on, off } from '@sparefoot/react-core/utils/dom';

const determineScreenSize = (width) => {
	const screenWidths = keys(breakpoints).sort(
		(a, b) => Number.parseInt(b, 10) - Number.parseInt(a, 10),
	);
	const breakWidth = find(
		screenWidths,
		(w) => Number.parseInt(w, 10) <= Number.parseInt(width, 10),
	);
	return breakpoints[breakWidth];
};

export default function useViewportWidth() {
	const [viewportWidth, setViewportWidth] = useState(0);
	const [breakpoint, setBreakpoint] = useState('small');

	const handleResize = useCallback(() => {
		const width = getWindowWidth();
		setViewportWidth(width);
		setBreakpoint(determineScreenSize(width));
	}, []);

	useEffect(() => {
		on('resize', handleResize);
		handleResize();
		return () => {
			off('resize', handleResize);
		};
	}, [handleResize]);

	return { viewportWidth, breakpoint, handleResize };
}
